<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'Customers' })"
  >
    <div
      class="modal-card"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Conversación
        </p>
      </header>
      <section class="modal-card-body">
        <IssoComments
          v-if="loaded"
          class="box"
          :loading="loading"
        />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'Customers' }"
        >
          Cerrar
        </RouterLink>
      </footer>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'CustomerChat',
  components: {
    IssoComments: () => import(/* webpackChunkName: "customers-invoices-history" */ '@/components/Isso/Isso.vue'),
  },
  data() {
    return {
      loading: false,
      loaded: false,
    };
  },
  async mounted() {
    this.loading = true;
    this.loaded = true;
    this.$store.dispatch('customers/getSingle', this.$route.params.customer);
  },
  methods: {
  },
};
</script>

<style scoped>
  /deep/ .modal-card-body .container {
    overflow-y: auto;
    min-height: 100px;
    max-height: 350px;
    padding: 5px;
  }
</style>
